// Header.js
import React, { useState, useEffect, useRef } from "react";
import { FaSearch } from "react-icons/fa";
// import { Popper, Paper, List, ListItem, ListItemText } from "@mui/material";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import {
  Menu,
  MenuItem,
  FormControlLabel,
  Switch,
  TextField,
  InputAdornment,
  Typography,
  IconButton,
  Button,
  Modal,
  Box,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import DefaultProfile from "../../Assets/img/Default-Profile.png"
import { IoSettingsSharp } from "react-icons/io5";
import profile_pic from "../../Assets/img/profile-pic2.jpg";
import { useQuantityContext } from "../QuantityContext";
import UserDetailContext, { useUserDetailContext } from "../UserDetailContext";
import NewBreadcrumb from "./NewBreadcrumb";
import { FaUserGear } from "react-icons/fa6";
import { MdDarkMode } from "react-icons/md";
import { ReactComponent as DisplayLabel } from "../../Assets/img/icons/Display label.svg";
import { ReactComponent as SupportNew } from "../../Assets/img/icons/support.svg";
import { ReactComponent as WhatsNew } from "../../Assets/img/icons/whats-new.svg";
import { ReactComponent as LogoutNew } from "../../Assets/img/icons/logout.svg";
import { FaBuilding } from "react-icons/fa";
import DefaultProfileBg from "../../Assets/img/card/profilebg.png";
import { ToastContainer, toast } from "react-toastify";
// import { getFirebaseToken, onForegroundMessage } from '../../config/firebase';
import NotificationPopup from "./NotificationPopup"; // Import the new component
import GlobalSearch from "./SubPages/GlobalSearch";
import { ReactComponent as DeleteAccount } from "../../Assets/img/icons/deleteAccount.svg";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Grid } from "rsuite";
import { useDispatch } from "react-redux";
import {
  postDeleteAccountReducer,
  postRevokeAccountReducer,
} from "../../Redux/Reducers/OnboardingReducer";
import axios from "axios";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  dropdownIcon: {
    cursor: "pointer",
  },
  menu: {
    marginTop: "40px",
  },
});

const Header = ({ setIsLightBoxVisible }) => {
  // const objectId = localStorage.getItem('objectId');
  const objectId = localStorage.getItem("objectId")?.trim();

  const rawUserDetails = localStorage.getItem("userDetails");
  const storedUserDetails =
    rawUserDetails && rawUserDetails !== "undefined"
      ? JSON.parse(rawUserDetails)
      : null; // Parse JSON

  const [toggleBtn, setToggleBtn] = useState(
    storedUserDetails?.is_delete_requested
  );
  const [showDeleteAccount, setShowDeleteAccount] = useState(false);
  const location = useLocation();
  const { userDetails } = useUserDetailContext();

  const apiKey = process.env.REACT_APP_API_KEY;
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
  };
  useEffect(() => {
    if (storedUserDetails) {
      setToggleBtn(storedUserDetails.is_delete_requested);
    }
  }, [storedUserDetails]);

  const dispatch = useDispatch();
  const { handleSuccess, handleInfo } = useQuantityContext();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [password, setPassword] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [PopupSortItem, setPopupSortItem] = useState(false);
  const [unreadCount, setUnreadCount] = useState(5);
  const [CompanyModal, setCompanyModal] = useState(false)
  const companies =
    useSelector((state) => state?.onboarding?.companies) || {};
  const [showNotificationBanner, setShowNotificationBanner] = useState(
    Notification.permission === "default"
  );
  // const [firebasetoken, setfirebasetoken] = useState('');
  const isHome = location.pathname === "/home";

  const [openRevoke, setOpenRevoke] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    setIsLightBoxVisible(true);
    // alert("logging out")
    // localStorage.removeItem('objectId');
    // Redirect to the login URL
    // window.location.href = "https://neoin.co/login_new";
  };

  const navigate = useNavigate();
  const handleDeleteAccount = () => {
    navigate("/delete-account");
    setShowDeleteAccount(false);
    handleClose();
  };

  const handleRevokeAccount = async () => {
    try {
      const payload = {
        password: password,
      };
      const response = await dispatch(postRevokeAccountReducer(payload));
      const userResponse = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${objectId}`,
          },
        }
      );
      const userData = userResponse?.data?.data?.user;
      console.log("Revoke response", response);
      if (response?.payload?.statusCode === 200) {
        // Call the userDetails API to set the details in localStorage

        localStorage.setItem("userDetails", JSON.stringify(userData));
        setOpenRevoke(false);
        handleSuccess("Account revoked successfully.");
        setToggleBtn(userResponse?.is_delete_requested);
      } else {
        setToggleBtn(true);
      }

      if (response?.payload?.statusCode === 404) {
        localStorage.setItem("userDetails", JSON.stringify(userData));
        setOpenRevoke(false);
        handleInfo("No Account Deletion Request found for the user");
        setToggleBtn(userResponse?.is_delete_requested);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const handleRevoke = () => {
    setOpenRevoke(true);
    handleClose();
  };

  // const handleIncrement = () => { if (quantity < 2) { setQuantity(prevQuantity => prevQuantity + 1); } };
  // const handleDecrement = () => { if (quantity > 1) { setQuantity(prevQuantity => prevQuantity - 1); } };

  const handleSortClick = () => {
    setPopupSortItem(!PopupSortItem);
  };

  const handleNewNotification = () => {
    setUnreadCount(unreadCount + 1);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isNotifyPopupOpen, setisNotifyPopupOpen] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]); // State to store pending requests

  const ToastifyNotification = ({ title, body }) => (
    <div className="push-notification">
      <h2 className="push-notification-title">{title}</h2>
      <p className="push-notification-text">{body}</p>
    </div>
  );

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleSearchClick = () => {
    setOpenSearch(true);
  };

  const [activeMenu, setActiveMenu] = useState("Personal");

  const handleMenuClick = (menuItem) => {
    setActiveMenu(menuItem);
  };

  const [openSearch, setOpenSearch] = useState(false);

  const handleOpenDeleteAccount = () => {
    setShowDeleteAccount(true);
  };

  const handleCreateComapny = () => {
    // setCompanyModal(true)
    // window.location.replace(`${baseUrl}/parentonboardingpage`);
    const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
    setCompanyModal(false);
    window.open(`${baseUrl}/`, '_blank');
  }

  return (
    <>
      <header className="header">
        <div className="header-left">
          {isHome && <span>Hi, Welcome to Neoin</span>}
        </div>
        <div className="header-right">
          {openSearch === false ? (
            <div className="icon">
              <FaSearch className="icon-color" onClick={handleSearchClick} />
            </div>
          ) : (
            <GlobalSearch setOpenSearch={setOpenSearch} />
          )}
          <NotificationPopup />
          {isPopupOpen && (
            <div className="popup-container">
              <div className="popup-header"></div>
              <div className="popup-content">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col">Notifications</div>
                    <div className="col-auto">
                      <div className="d-flex align-items-center m-0 p-0">
                        <div className="icon">
                          <IoSettingsSharp className="icon-color2" />
                        </div>
                        <button
                          type="button"
                          className="lightbox__close2"
                          onClick={togglePopup}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="menu container justify-content-between">
                  <div
                    className={`menu-item ${activeMenu === "Personal" ? "active" : ""
                      }`}
                    onClick={() => handleMenuClick("Personal")}
                  >
                    <div className="container-gift">
                      <span>Personal</span>
                    </div>
                  </div>
                  <div
                    className={`menu-item ${activeMenu === "Professional" ? "active" : ""
                      }`}
                    onClick={() => handleMenuClick("Professional")}
                  >
                    <div className="container-gift">
                      <span>Professional</span>
                    </div>
                  </div>
                  <div
                    className={`menu-item ${activeMenu === "Financial" ? "active" : ""
                      }`}
                    onClick={() => handleMenuClick("Financial")}
                  >
                    <div className="container-gift">
                      <span>Financial</span>
                    </div>
                  </div>
                  <div
                    className={`menu-item ${activeMenu === "Others" ? "active" : ""
                      }`}
                    onClick={() => handleMenuClick("Others")}
                  >
                    <div className="container-gift">
                      <span>Others</span>
                    </div>
                  </div>
                </div>

                {activeMenu === "Personal" && (
                  <div className="menu-content pr-2">
                    <div className="menu-item menu-item-person d-flex align-items-center">
                      <span>
                        <img
                          className="chat-profile"
                          src={profile_pic}
                          alt=""
                        />
                      </span>
                      <span>
                        <h6>Heading</h6>
                        <p>This is a sub-paragraph.</p>
                      </span>
                      <span>Profile</span>
                    </div>
                  </div>
                )}
                {activeMenu === "Professional" && (
                  <div className="menu-content">
                    Some Content for Professional Side
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="icon">
            <div className="status-new profile-box-2">
              <div className="circle-cont-2">
                <img
                  src={userDetails.proFile || DefaultProfileBg}
                  alt="profile"
                />
              </div>
              <div className="profile-content-container">
                <div className="profile-name">
                  <h2 className="profile-name-content truncate fw-normal">
                    {userDetails.name}
                  </h2>
                </div>
                <div className="profile-subox">
                  <div
                    className="probile-subox-cont"
                    style={{ color: "black" }}
                  >
                    UID: {userDetails?.uniqueId}
                  </div>
                </div>
              </div>

              <div className="me-1">
                <ArrowDropDownRoundedIcon
                  className={classes.dropdownIcon}
                  onClick={handleClick}
                />
                <Menu
                  id="simple-menu-for-header"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  className={classes.menu}
                >
                  {showDeleteAccount ? (
                    <MenuItem onClick={handleDeleteAccount}>
                      <div className="user-profile">
                        {/* <LogoutNew className="user-icon" /> */}
                        <DeleteAccount className="user-icon" />
                        <span className="user-text">Delete Account</span>
                      </div>
                    </MenuItem>
                  ) : (
                    <>
                      <MenuItem onClick={handleOpenDeleteAccount}>
                        <div className="user-profile">
                          <FaUserGear className="icon-color" />
                          <span className="user-text">User Settings</span>
                        </div>
                      </MenuItem>

                      <MenuItem>
                        <div className="user-profile">
                          <DisplayLabel className="user-icon" />
                          <span className="user-text">Display Label</span>
                          {/* <FormGroup>
                        <FormControlLabel control={<Switch />} />
                      </FormGroup> */}
                          <FormControlLabel control={<Switch />} />
                        </div>
                      </MenuItem>
                      <MenuItem>
                        <div className="user-profile">
                          <MdDarkMode className="icon-color" />
                          <span className="user-text">Dark Mode</span>
                          <FormControlLabel control={<Switch />} />
                        </div>
                      </MenuItem>
                      <MenuItem>
                        <div className="user-profile">
                          <SupportNew className="user-icon" />
                          <span className="user-text">Support</span>
                        </div>
                      </MenuItem>
                      <MenuItem>
                        <div className="user-profile">
                          <WhatsNew className="user-icon" />
                          <span className="user-text">Whats New</span>
                        </div>
                      </MenuItem>
                      <MenuItem onClick={handleCreateComapny}>
                        <div className="user-profile">
                          <FaBuilding className="user-icon" style={{ color: "gray" }} />
                          <span className="user-text">Company</span>
                        </div>
                      </MenuItem>
                      <MenuItem onClick={handleLogout}>
                        <div className="user-profile">
                          <LogoutNew className="user-icon" />
                          <span className="user-text">Logout</span>
                        </div>
                      </MenuItem>
                      {!toggleBtn ? (
                        ""
                      ) : (
                        <MenuItem onClick={handleRevoke}>
                          <div className="user-profile">
                            {/* <DeleteAccount className="user-icon" /> */}
                            <PersonAddIcon color="action" />
                            <span className="user-text">Revoke Account</span>
                          </div>
                        </MenuItem>
                      )}
                    </>
                  )}
                </Menu>

                {openRevoke && (
                  <div className="lightbox-overlay">
                    <div className="lightbox-content p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6
                          className="mb-0"
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "black",
                          }}
                        >
                          Do you want to Revoke this Account?
                        </h6>
                        <IconButton onClick={() => setOpenRevoke(false)}>
                          <CloseRoundedIcon />
                        </IconButton>
                      </div>
                      <Typography variant="body2" className="text-muted">
                        {" "}
                        By revoking your account, you can stay connected with
                        your friends and connections.
                      </Typography>

                      <div className="mt-3">
                        <Grid container>
                          <Grid item xs={12}>
                            <TextField
                              variant="outlined"
                              label="Type Password"
                              fullWidth
                              type="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </Grid>
                        </Grid>
                      </div>

                      {errorMessage && (
                        <Typography variant="body2" color="error">
                          {errorMessage}
                        </Typography>
                      )}

                      <div className="d-flex justify-content-end">
                        <Button
                          onClick={() => setOpenRevoke(false)}
                          className="mx-2 mt-2"
                        >
                          CANCEL
                        </Button>
                        <Button
                          onClick={handleRevokeAccount}
                          className="delete-button_configuration mt-2"
                        >
                          REVOKE
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      <Modal
        open={Boolean(CompanyModal)}
        onClose={() => setCompanyModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          style={{
            backgroundColor: "white",
            borderRadius: "12px",
            padding: "32px",
            maxWidth: "450px",
            width: "90%",
            boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
            outline: "none",
            position: "relative",
          }}
        >
          <IconButton
            onClick={() => setCompanyModal(false)}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              color: "#666"
            }}
          >
            <CloseRoundedIcon />
          </IconButton>

          <Box style={{ textAlign: "center", padding: "16px 0" }}>
            <Typography variant="h6" style={{
              fontWeight: 600,
              color: "#333",
              marginBottom: "16px"
            }}>
              Create Your Company
            </Typography>
            <Typography variant="body2" style={{
              color: "#666",
              marginBottom: "24px",
              lineHeight: 1.5
            }}>
              To access company features, you need to create or register your company first
            </Typography>

            <Box style={{
              display: "flex",
              gap: "16px",
              justifyContent: "center",
              marginTop: "32px"
            }}>
              <Button
                variant="outlined"
                onClick={() => setCompanyModal(false)}
                style={{
                  borderColor: "#ddd",
                  color: "#666",
                  textTransform: "none",
                  padding: "8px 24px"
                }}
              >
                Maybe Later
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
                  setCompanyModal(false);
                  window.open(`${baseUrl}/`, '_blank');
                }}
                style={{
                  backgroundColor: "#0044C6",
                  color: "white",
                  textTransform: "none",
                  borderRadius: "5px",
                  padding: "8px 32px"
                }}
              >
                Create Company
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <ToastContainer />

      <NewBreadcrumb />
      {/* <Breadcrumb /> */}
    </>
  );
};

export default Header;
